export default __webpack_public_path__ + "static/media/Hamburger.9203ed2d.svg";